import { defineStore } from 'pinia'

export const useGlobalStore = defineStore('global', {
  state: () => {
    return {
      isSidebarMinimized: true,
    }
  },

  actions: {
    toggleSidebar() {
      this.isSidebarMinimized = !this.isSidebarMinimized
    },
    setSideBar(value) {
      this.isSidebarMinimized = value
    },
  },
})

// const global = useGlobalStore()
// global.setSideBar(true)
